import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingButton } from "@mui/lab";
export function StepperCTAButton(props) {
    return (_jsx(LoadingButton, { "data-testid": "continue-button", size: "large", variant: "contained", fullWidth: true, ...props }));
}
